// extracted by mini-css-extract-plugin
export var flexColumn = "CurrentPlanCard_flexColumn__oci49";
export var price = "CurrentPlanCard_price__Qm8SK";
export var wrapper = "CurrentPlanCard_wrapper__abWdk";